import axios from '@store/axios'
import parseUrl from '@/core/helpers/parseUrl'
import each from 'lodash/each'

const PROVIDER_IDV_URL =
  'https://clin-table-search.lhc.nlm.nih.gov/api/npi_idv/v3/search?terms&df&maxList'

// const PROXY_URL = 'https://cors-anywhere.herokuapp.com/'
// const GEOCODING_ORG_URL =
//   'https://maps.googleapis.com/maps/api/geocode/json?&address&key'
const PROVIDER_ORG_URL =
  'https://clin-table-search.lhc.nlm.nih.gov/api/npi_idv/v3/search?terms&df&maxList'
// // 'https://clin-table-search.lhc.nlm.nih.gov/api/npi_org/v3/search?terms&df&maxList'
// const PROVIDER_ORG_KEY = 'AIzaSyBhHTQWfKsJSMkk8Be_ajV6oAbwCy79PlU'

const PROVIDER_IDV_FIELDS = [
  'NPI',
  'provider_type',
  'name.first',
  'name.last',
  'name.credential',
  'addr_practice.line1',
  'addr_practice.line2',
  'addr_practice.city',
  'addr_practice.state',
  'addr_practice.zip',
  'addr_practice.phone',
  'addr_practice.fax'
]

const PROVIDER_ORG_FIELDS = [
  'NPI',
  'name.full',
  'addr_practice.line1',
  'addr_practice.line2',
  'addr_practice.city',
  'addr_practice.state',
  'addr_practice.zip',
  'addr_practice.phone',
  'addr_practice.fax'
]

export default {
  addProvider({ commit }, provider) {
    const url = '/providers'
    return axios.post(url, provider)
  },
  getProviders({ commit }) {
    const url = '/providers'
    return axios.get(url).then(({ data }) => {
      commit('setProviders', data)
      return data
    })
  },
  getInvidualProvider({ commit }, { npi }) {
    const terms = npi
    const df = PROVIDER_IDV_FIELDS.join(',')
    const maxList = 1
    const url = parseUrl(PROVIDER_IDV_URL, { terms, df, maxList })

    return axios.get(url).then(({ data }) => {
      let searchResults = []
      let item = data[3][0] // get first item
      let searchResultItem = {
        npi: item[0],
        type: item[1],
        name: item[2] + ' ' + item[3],
        first: item[2],
        last: item[3],
        credential: item[4],
        displayNameIndividual: item[2] + ' ' + item[3] + ' ' + item[4],
        address: {
          line1: item[5],
          line2: item[6],
          city: item[7],
          state: item[8],
          zip: item[9]
        },
        displayAddressIndividual:
          item[5] +
          ' ' +
          item[6] +
          ' ' +
          item[7] +
          ' ' +
          item[8] +
          ' ' +
          item[9],
        phone: item[10],
        fax: item[11],
        email: '',
        notes: ''
      }
      commit('setProvider', searchResultItem)
      return searchResults
    })
  },
  getGoogleProvider({ commit }, { googleProvider }) {
    let searchResults = [googleProvider]
    commit('setProvider', googleProvider)
    return searchResults
  },
  getIndividualProviderForRequestDisplay({ commit }, { npi }) {
    const terms = npi
    const df = PROVIDER_IDV_FIELDS.join(',')
    const maxList = 1
    const url = parseUrl(PROVIDER_IDV_URL, { terms, df, maxList })
    return axios.get(url).then(({ data }) => {
      let item = data[3][0] // get first item
      let searchResultItem = {
        npi: item[0],
        type: item[1],
        name: item[2] + ' ' + item[3],
        first: item[2],
        last: item[3],
        credential: item[4],
        displayNameIndividual: item[2] + ' ' + item[3] + ' ' + item[4],
        address: {
          line1: item[5],
          line2: item[6],
          city: item[7],
          state: item[8],
          zip: item[9]
        },
        displayAddressIndividual:
          item[5] +
          ' ' +
          item[6] +
          ' ' +
          item[7] +
          ' ' +
          item[8] +
          ' ' +
          item[9],
        phone: item[10],
        fax: item[11],
        email: '',
        notes: ''
      }
      return searchResultItem
    })
  },
  getOrganizationProvider({ commit }, { npi }) {
    const terms = npi
    const df = PROVIDER_ORG_FIELDS.join(',')
    const maxList = 1
    const url = parseUrl(PROVIDER_ORG_URL, { terms, df, maxList })

    return axios.get(url).then(({ data }) => {
      let searchResults = []
      let item = data[3][0] // get first item
      let searchResultItem = {
        npi: item[0],
        name: item[1],
        address: {
          line1: item[2],
          line2: item[3],
          city: item[4],
          state: item[5],
          zip: item[6]
        },
        phone: item[7],
        fax: item[8],
        email: '',
        notes: ''
      }
      commit('setProvider', searchResultItem)
      return searchResults
    })
  },
  search({ dispatch, commit }, { type, terms }) {
    if (terms && terms.trim()) {
      if (type === 'org') {
        return dispatch('simplySearch', { terms })
      }
      return dispatch('simplySearch', { terms })
    } else {
      commit('setSearchResults', [])
    }
  },
  simplySearch({ commit }, { terms }) {
    const df = PROVIDER_IDV_FIELDS.join(',')
    const url = parseUrl(PROVIDER_IDV_URL, { terms, df })
    let searchResults = []
    axios.get(url).then(({ data }) => {
      let list = data[3]
      each(list, item => {
        let searchResultItem = {
          avatar: 'person',
          npi: item[0],
          type: item[1],
          name: item[2] + ' ' + item[3],
          first: item[2],
          last: item[3],
          credential: item[4],
          displayNameIndividual: item[2] + ' ' + item[3] + ' ' + item[4],
          selectionDisplayName: item[2].toLowerCase().replace(/^\w/, c => c.toUpperCase()) + ' ' + item[3].toLowerCase().replace(/^\w/, c => c.toUpperCase()) + ' ' + item[4],
          displayName: item[2] + ' ' + item[3] + ' ' + item[4],
          displayLocale: item[7] + ', ' + item[8],
          address: {
            line1: item[5],
            line2: item[6],
            city: item[7],
            state: item[8],
            zip: item[9]
          },
          displayAddressIndividual:
            item[5] +
            ' ' +
            item[6] +
            ' ' +
            item[7] +
            ' ' +
            item[8] +
            ' ' +
            item[9],
          phone: item[10],
          fax: item[11],
          email: '',
          notes: ''
        }
        searchResults.push(searchResultItem)
      })
      commit('setSearchResults', searchResults)
    })
    return searchResults
  },
  searchByIndiviual({ commit }, { terms }) {
    const df = PROVIDER_IDV_FIELDS.join(',')
    const url = parseUrl(PROVIDER_IDV_URL, { terms, df })
    return axios.get(url).then(({ data }) => {
      let searchResults = []
      let list = data[3]
      each(list, item => {
        let searchResultItem = {
          npi: item[0],
          type: item[1],
          name: item[2] + ' ' + item[3],
          first: item[2],
          last: item[3],
          credential: item[4],
          displayNameIndividual: item[2] + ' ' + item[3] + ' ' + item[4],
          address: {
            line1: item[5],
            line2: item[6],
            city: item[7],
            state: item[8],
            zip: item[9]
          },
          displayAddressIndividual:
            item[5] +
            ' ' +
            item[6] +
            ' ' +
            item[7] +
            ' ' +
            item[8] +
            ' ' +
            item[9],
          phone: item[10],
          fax: item[11],
          email: '',
          notes: ''
        }
        searchResults.push(searchResultItem)
      })
      commit('setSearchResults', searchResults)
      return searchResults
    })
  },
  searchByOrganization({ commit }, { terms }) {
    const df = PROVIDER_ORG_FIELDS.join(',')
    const url = parseUrl(PROVIDER_ORG_URL, { terms, df })
    return axios.get(url).then(({ data }) => {
      let searchResults = []
      let list = data[3]
      each(list, item => {
        let searchResultItem = {
          npi: item[0],
          name: item[1],
          address: {
            line1: item[2],
            line2: item[3],
            city: item[4],
            state: item[5],
            zip: item[6]
          },
          phone: item[7],
          fax: item[8],
          email: '',
          notes: ''
        }
        searchResults.push(searchResultItem)
      })
      commit('setSearchResults', searchResults)
      return searchResults
    })
  },
  // searchByOrganization({ commit }, { terms }) {

  //   // TODO: Set up geocode url
  //   const geoUrl = parseUrl(GEOCODING_ORG_URL, {
  //     address: terms,
  //     key: PROVIDER_ORG_KEY
  //   })
  //   return axios.get(geoUrl).then(() => {
  //     const url = parseUrl(PROVIDER_ORG_URL, {
  //       query: terms,
  //       type: 'hospital',
  //       key: PROVIDER_ORG_KEY
  //     })
  //     return axios
  //       .get(url)
  //       .then(({ data }) => {
  //         console.log(data)
  //         let searchResults = []
  //         let list = data[3]
  //         each(list, item => {
  //           let searchResultItem = {
  //             npi: item[0],
  //             name: item[1],
  //             address: {
  //               line1: item[2],
  //               line2: item[3],
  //               city: item[4],
  //               state: item[5],
  //               zip: item[6]
  //             },
  //             phone: item[7],
  //             fax: item[8],
  //             email: '',
  //             notes: ''
  //           }
  //           searchResults.push(searchResultItem)
  //         })
  //         commit('setSearchResults', searchResults)
  //         return searchResults
  //       })
  //       .catch(error => {
  //         console.log(error)
  //       })
  //   })
  // },
  requestDocs(
    { commit },
    { provider, patient, startDate, endDate, signature }
  ) {
    const url = parseUrl('/providers/:id/requests', { id: provider.npi })
    return axios.post(url, {
      patientID: patient._id,
      start: startDate,
      end: endDate,
      sigPNGBase64: signature
    })
  },
  requestMissingProvider(
    { commit },
    { provider, patient, startDate, endDate, signature, userFeedback }
  ) {
    const url = '/missing_provider_request'
    return axios.post(url, {
      patientID: patient._id,
      start: startDate,
      end: endDate,
      sigPNGBase64: signature,
      missingProviderInfo: userFeedback
    })
  },
  getPartner({ commit, dispatch }, { npi }) {
    return dispatch('getPartners', {
      npis: [npi]
    }).then(partners => {
      commit('setPartner', partners[0])
      return partners[0]
    })
  },
  getPartners({ commit }, { npis, ids }) {
    const url = parseUrl('/partners?npis&ids', { npis: npis, ids: ids })
    return axios.get(url).then(({ data }) => {
      commit('setPartners', data)
      return data
    })
  },
  getProviderAuth({ commit }, { ids }) {
    const url = parseUrl('/public/providers?ids', { ids: ids })
    return axios.get(url).then(({ data }) => {
      commit('setProviderAuth', data)
      return data
    })
  },
  setTheLocalProviderList({ commit }, { ids }) {
    const url = parseUrl('/public/providers?ids', { ids: ids })
    return axios.get(url).then(({ data }) => {
      commit('setLocalProviderList', data)
      return data
    })
  },
  getProviderIDFromNPI({ commit }, { npis }) {
    const url = parseUrl('/public/providers?npis', { npis: npis })
    return axios.get(url).then(({ data }) => {
      return data
    })
  },
  getProviderIDFromGooglePlacesID({ commit }, { googlePlaceIDs }) {
    console.log(googlePlaceIDs)
    const url = parseUrl('/public/providers?googlePlaceIDs', {
      googlePlaceIDs: googlePlaceIDs
    })
    return axios.get(url).then(({ data }) => {
      console.log('google places get id return')
      console.log(data)
      return data
    })
  },
  getProviderInfo({ commit }, { ids }) {
    const url = parseUrl('/public/providers?ids', { ids: ids })
    return axios.get(url).then(({ data }) => {
      return data
    })
  },
  confirmProviders({ commit }, { provider, providerCode }) {
    const url = parseUrl(
      '/providers/:npi/affiliate/:code',
      { npi: provider },
      { code: providerCode }
    )
    return axios.post(url)
  },
  shareChart(_, { faxes, emails, patients, files }) {
    console.log('share the chart')
    let payload = {}

    let subdomain = window.location.hostname.split('.')[0]
    if (subdomain) {
      payload['subdomain'] = subdomain
    }

    payload['emails'] = emails
    payload['faxes'] = faxes
    payload['patients'] = patients
    payload['files'] = files
    // TODO add subdomain

    const url = parseUrl('/shares')
    return axios.post(url, payload).then(({ data }) => {
      return data
    })
  },
  generateSharingLink({ commit }, { faxes, emails, patients, files }) {
    let payload = {}
    let subdomain = window.location.hostname.split('.')[0]

    if (subdomain) {
      payload['subdomain'] = subdomain
    }

    payload['emails'] = emails
    payload['faxes'] = faxes
    payload['patients'] = patients
    payload['files'] = files
    // TODO add subdomain

    const url = parseUrl('/shares')
    return axios.post(url, payload).then(({ data }) => {
      let link = 'https://patient.onecharthealth.com/shared/' + data.share._id
      commit('setSharingLink', link)
      return data
    })
  },
  clearSharingLink({ commit }) {
    commit('setSharingLink', null)
  },
  multipleShareFiles(_, { providers, emails, files }) {
    let payload = {}
    let filesHere = {}

    each(files, file => {
      filesHere[file._id] = ['VIEW']
    })

    payload['files'] = filesHere
    payload['emails'] = emails
    payload['providers'] = providers

    const url = parseUrl('/share')
    return axios.post(url, payload).then(({ data }) => {
      return data
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/provider/actions.js